export class Type {
    id!: string;
    title: string = '';
    imageLink: string = '';
    parentId: string = '';

    static map(data: TypeResponse) {
        const item = new Type();
        item.id = data.id;
        item.title = data.title || '';
        item.imageLink = data.imageLink || '';
        item.parentId = data.parentTypeId ? data.parentTypeId.id : '';
        return item;
    }
}

export interface TypeResponse {
    id: string;
    title: string;
    imageLink: string|null;
    parentTypeId: TypeResponse;
}
